
import { mapState } from 'vuex'
import Spinner from 'vux/src/components/spinner/index.vue'

export default {
name: 'v-loading',
components: {
Spinner
},
props: {
show: {
type: Boolean
}
},
computed: {
...mapState([
'styleColor'
])
}
};



// WEBPACK FOOTER //
// ./src/components/Loading.vue